import React from "react";
import "../CustomButton/CustomButton.css";

const CustomButt = ({ text, rounded = true, handleButtonClick, fullWidth = true }) => {
  return (
    <button
      onClick={handleButtonClick}
      className={`transition-all custom-button bg-[var(--medium-sea-green)] hover:bg-[var(--sea-green)] inline-block ${
        rounded ? "md:rounded-md" : ""
      } text-white font-semibold py-2 sm:py-3 px-4 sm:px-6 md:px-7 ${
        fullWidth ? "w-full sm:w-auto sm:max-w-[215px]" : "w-full md:w-auto md:max-w-full"
      } overflow-hidden text-ellipsis whitespace-nowrap text-sm md:text-base`}
    >
      <span className="">{text}</span>
    </button>
  );
};

export default CustomButt;